/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 8c15fa5d0ffb
 */

import * as z from "zod";

export type UploadMappingMutationResponse = {
  message: string;
  external_id: string;
};

export const UploadMappingMutationResponse$zodSchema: z.ZodType<
  UploadMappingMutationResponse
> = z.object({
  external_id: z.string().describe("Unique identifier of the mapping."),
  message: z.string(),
});
